export enum PopupType {
    INFO = "info",
    ERROR = "error",
    CONFIRMATIN = "confirmation",
}
